import { SEARCH_FORM } from '../constants'

export const setSearchFormData = (searchFormData) => ({
	type: SEARCH_FORM.SET_FORM_DATA,
	searchFormData,
})
